import { STATUS_ICON_CHECK_O, STATUS_ICON_LOADING, STATUS_ICON_TIMES_O, STATUS_ICON_INACTIVE, STATUS_ICON_CLOCK } from '@/common/utils/statuses';
import computedLocale from '@/common/utils/computedLocale';
import i18n from '@/common/i18n';
import { MigrationTask } from '@schema';

export type MigrationTaskStatus = MigrationTask.status;
export const MigrationTaskStatus = MigrationTask.status;

export const MIGRATION_TASK_STATUS_TEXT = computedLocale<Record<MigrationTaskStatus, string>>(() => ({
  [MigrationTaskStatus.SCHEDULED]: i18n.t('Scheduled'),
  [MigrationTaskStatus.UNSCHEDULED]: i18n.t('Unscheduled'),
  [MigrationTaskStatus.PENDING]: i18n.t('Pending'),
  [MigrationTaskStatus.STARTING]: i18n.t('Starting'),
  [MigrationTaskStatus.RUNNING]: i18n.t('Running'),
  [MigrationTaskStatus.CANCELLING]: i18n.t('Canceling'),
  [MigrationTaskStatus.CANCELLING_AFTER_COMPLETION]: i18n.t('Canceling'),
  [MigrationTaskStatus.COMPLETED]: i18n.t('Completed'),
  [MigrationTaskStatus.ERROR]: i18n.t('Error'),
  [MigrationTaskStatus.CANCELED]: i18n.t('Canceled'),
  [MigrationTaskStatus.CANCELED_AFTER_COMPLETION]: i18n.t('Canceled'),
  [MigrationTaskStatus.FORCE_CANCELED]: i18n.t('Canceled'),
  [MigrationTaskStatus.CANCELED_FOR_DEBUGGING]: i18n.t('Canceled for debugging'),
  [MigrationTaskStatus.STRANDED_AFTER_DEADLOCK]: i18n.t('Deadlocked'),
  [MigrationTaskStatus.FAILED_TO_SCHEDULE]: i18n.t('Failed to schedule'),
  [MigrationTaskStatus.FAILED_TO_CANCEL]: i18n.t('Failed to cancel'),
}));

export const MIGRATION_TASK_STATUS_ICON: Record<MigrationTaskStatus, string> = {
  [MigrationTaskStatus.SCHEDULED]: STATUS_ICON_CLOCK,
  [MigrationTaskStatus.UNSCHEDULED]: STATUS_ICON_CLOCK,
  [MigrationTaskStatus.PENDING]: STATUS_ICON_CLOCK,
  [MigrationTaskStatus.STARTING]: STATUS_ICON_LOADING,
  [MigrationTaskStatus.RUNNING]: STATUS_ICON_LOADING,
  [MigrationTaskStatus.CANCELLING]: STATUS_ICON_LOADING,
  [MigrationTaskStatus.CANCELLING_AFTER_COMPLETION]: STATUS_ICON_LOADING,
  [MigrationTaskStatus.COMPLETED]: STATUS_ICON_CHECK_O,
  [MigrationTaskStatus.ERROR]: STATUS_ICON_TIMES_O,
  [MigrationTaskStatus.CANCELED]: STATUS_ICON_INACTIVE,
  [MigrationTaskStatus.CANCELED_AFTER_COMPLETION]: STATUS_ICON_INACTIVE,
  [MigrationTaskStatus.FORCE_CANCELED]: STATUS_ICON_INACTIVE,
  [MigrationTaskStatus.CANCELED_FOR_DEBUGGING]: STATUS_ICON_INACTIVE,
  [MigrationTaskStatus.STRANDED_AFTER_DEADLOCK]: STATUS_ICON_TIMES_O,
  [MigrationTaskStatus.FAILED_TO_SCHEDULE]: STATUS_ICON_TIMES_O,
  [MigrationTaskStatus.FAILED_TO_CANCEL]: STATUS_ICON_TIMES_O,
};
